import { Component, inject } from "@angular/core"
import { MAT_DIALOG_DATA, MatDialogClose, MatDialogContent } from "@angular/material/dialog"
import { MatIcon } from "@angular/material/icon"
import { SuperiorEvaluationData } from "src/app/models"

@Component({
    selector: "valben-superior-evaluation-dialog",
    templateUrl: "./superior-evaluation-dialog.component.html",
    standalone: true,
    imports: [MatDialogContent, MatDialogClose, MatIcon],
})
export class SuperiorEvaluationDialogComponent {
    readonly data = inject<SuperiorEvaluationData | null>(MAT_DIALOG_DATA)
}
